// extracted by mini-css-extract-plugin
module.exports = {"LanguageBadgeWrap":"styles-module--LanguageBadgeWrap--2NR-X","LanguageBadge":"styles-module--LanguageBadge--3zU-c","CopyButton":"styles-module--CopyButton--2SgPf"};